const ISIN_PATTERN = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/;
const ALPHANUMERIC_RADIX = 36;
const LUHN_DOUBLING_FACTOR = 2;
const LUHN_MAX_DIGIT = 9;
const LUHN_MODULUS = 10;

export const normalizeIsin = (value: string) =>
	value.replace(/\s/g, "").toUpperCase();

const toDigits = (isin: string) =>
	[...isin]
		.map((character) =>
			Number.parseInt(character, ALPHANUMERIC_RADIX).toString(),
		)
		.join("");

const hasValidLuhnChecksum = (digits: string) => {
	const sum = [...digits].reverse().reduce((acc, curr, index) => {
		const digit = Number(curr);
		if (index % LUHN_DOUBLING_FACTOR === 0) {
			return acc + digit;
		}
		const doubled = digit * LUHN_DOUBLING_FACTOR;
		return (
			acc + (doubled > LUHN_MAX_DIGIT ? doubled - LUHN_MAX_DIGIT : doubled)
		);
	}, 0);

	return sum % LUHN_MODULUS === 0;
};

export const isValidIsin = (value: string) => {
	const isin = normalizeIsin(value);

	return ISIN_PATTERN.test(isin) && hasValidLuhnChecksum(toDigits(isin));
};
